<template>
  <div class="delete-owner-room-container">
    <!-- (1) PageHeader -->
    <ds-page-header :title="$t('deleteOwnerRoom.page.title')" :subtitle="$t('deleteOwnerRoom.page.subtitle')" />

    <!-- 业主信息 -->
    <view-owner-info ref="viewOwnerInfo" :show-call-back-button="true" @notify="handleNotify" @callBackListOwner="goBack" />

    <!-- 业主房屋信息 -->
    <show-owner-room :deleteOwnerRoomFlag="deleteOwnerRoomFlag" :ownerId="ownerId" :ownerName="ownerName" />
  </div>
</template>

<script>
import ViewOwnerInfo from '@/components/owner/viewOwnerInfo'
import ShowOwnerRoom from '@/components/owner/showOwnerRoom'
import DsPageHeader from '@/components/ds/ds-page-header.vue'

export default {
  name: 'DeleteOwnerRoomList',
  components: {
    ViewOwnerInfo,
    ShowOwnerRoom,
    DsPageHeader
  },
  data() {
    return {
      ownerId: '',
      ownerName: '',
      deleteOwnerRoomFlag: true
    }
  },
  created() {
    this.ownerId = this.$route.query.ownerId
  },
  methods: {
    handleNotify(ownerInfo) {
      // 处理返回通知
      console.log('Received notify:', ownerInfo)
      // 这里可以添加其他处理逻辑
    },
    goBack() {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="scss" scoped>
.delete-owner-room-container {
  padding: var(--ds-spacing-lg);
  background-color: var(--ds-gray-100);
  min-height: calc(100vh - 60px);
}
</style>
